import { SAVE_PRODUCT_SUGGESTIONS } from '../actions/types'

export default (state = '', action) => {
  switch (action.type) {
    case SAVE_PRODUCT_SUGGESTIONS:
      return action.payload
    default:
      return state
  }
}
